import { Anchor, Center, Text } from '@mantine/core';
import { IconArrowRight, IconCircleCheck } from '@tabler/icons-react';
import { useDebtor } from 'app/Private/Clients/Detail/client-atom';
import { iconProps } from 'components/index';
import { NavButton } from 'components/NavButton';
import { Panel } from 'components/Panel';
import { tKeys, useTranslation } from 'locales';
import { useLoadUnhandledClients } from 'modules/AtRisk/api/use-load-unhandled-clients';
import { Link } from 'react-router-dom';
import { isNullish } from 'remeda';

export const UnhandledInvoicesNextAction = () => {
  const { t } = useTranslation();

  const nextUrl = useGetNextClientUrl();
  const {
    unhandledClients: { unhandledClients },
  } = useLoadUnhandledClients({});

  if (isNullish(nextUrl)) return null;

  return (
    <Panel fullHeight>
      <Center h="100%" style={{ flexDirection: 'column' }}>
        <IconCircleCheck size={100} color="var(--mantine-color-purple-6)" />
        <Text mt={25} fz="xl" fw={700} ta="center">
          {t(tKeys.MODULES.AT_RISK.NEXT_ACTION.TITLE)}
        </Text>
        <Text mt="sm" c="dimmed" ta="center" maw={400}>
          {t(tKeys.MODULES.AT_RISK.NEXT_ACTION.DESCRIPTION_PREFIX)}{' '}
          <Text component="span" fw={700} c="purple">
            {unhandledClients.length}
          </Text>{' '}
          {t(tKeys.MODULES.AT_RISK.NEXT_ACTION.DESCRIPTION_SUFFIX)}
        </Text>
        <NavButton
          mt="xl"
          rightSection={<IconArrowRight {...iconProps()} />}
          to={nextUrl}
          label={t(tKeys.MODULES.AT_RISK.NEXT_ACTION.NEXT_CLIENT)}
        />
        <Anchor component={Link} to="/needs-handling/handle-clients" c="dimmed" size="sm" mt="md">
          {t(tKeys.MODULES.AT_RISK.NEXT_ACTION.BACK_TO_LIST)}
        </Anchor>
      </Center>
    </Panel>
  );
};

function useGetNextClientUrl(): string | null {
  const debtor = useDebtor();
  const {
    unhandledClients: { unhandledClients },
  } = useLoadUnhandledClients({});

  const nextClient = unhandledClients.find(c => c.id !== String(debtor.id));
  return nextClient ? `/clients/${nextClient.id}#at-risk` : null;
}
